import { render, staticRenderFns } from "./BoxingList.vue?vue&type=template&id=6eea0030&scoped=true&"
import script from "./BoxingList.vue?vue&type=script&lang=js&"
export * from "./BoxingList.vue?vue&type=script&lang=js&"
import style0 from "./BoxingList.vue?vue&type=style&index=0&id=6eea0030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea0030",
  null
  
)

export default component.exports